<template>
    <div id="master-footer" class="d-flex bg-light shadow">

    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    #master-footer {
        height: 50px;
        z-index: 7;
    }
</style>


// WEBPACK FOOTER //
// src/components/master/master-footer.vue